<!-- ------------------------------------------ creation Eng Ahmed Abdelhameed ALi ------------------------------------------ -->

<div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="addIndustrySector" (ngSubmit)="submit()">
        <div class="form-group">
            <label for="validationCustom01">{{'GENERAL.ENGLISH_NAME' | translate}}</label>
            <input type="text" class="form-control" formControlName="nameInEnglish" 
            [ngClass]="{'is-valid':getAddIndustrySector.nameInEnglish.dirty,'is-invalid':getAddIndustrySector.nameInEnglish.invalid}">
        </div>
        <div class="form-group">
            <label for="validationCustom01">{{'GENERAL.ARABIC_NAME' | translate}}</label>
            <input type="text" class="form-control" formControlName="nameInArabic"
            [ngClass]="{'is-valid':getAddIndustrySector.nameInArabic.dirty,'is-invalid':getAddIndustrySector.nameInArabic.invalid}">
        </div>
        <div class="modal-footer d-flex justify-content-center">
            <button type="submit" class="btn btn-primary">save</button>
          </div>
    </form>
</div>
